export default (params) => ({
  trigger: {
    name: 'content_blocks.product_row.select_item',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      method: {
        enum: [
          'image',
          'title',
        ],
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'personalized_assortment',
          'recently_viewed',
          'bestsellers',
          'featured_items',
          'related_products',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_item',
    },
  },
});
